import { type AnimationData } from '../types';

/**
 * Get merged animation data from both D4 and D5 global variables.
 *
 * D5 has different global variable name to ensure compatibility when there are both D4 and D5 modules
 * on the same page. Both animation data formats are merged here.
 *
 * @since ??
 *
 * @returns {AnimationData[]} Merged animation data array.
 */
export const getMergedAnimationData = (): AnimationData[] => [
  ...(window?.et_animation_data ?? []),
  ...(window?.diviElementAnimationData ?? []),
];
